export default __webpack_public_path__ + "static/media/Video Thumbnail Car Servicing.a750e225.png";